<template>
  <div>
    <div class="additional-menu">
      <MenuItem
        :item="item"
        :class="{'router-link-active': showDialog}"
        @click.native="openDialog"
      />
    </div>

    <contact-us
      v-if="showDialog"
      class="contact-us__popup"
      v-on:close-dialog="closeDialog"
      :showDialog="showDialog"
    />
  </div>

</template>

<script>
  import MenuItem from './mainMenu/menuItem.vue'
  import ContactUs from './contact-us_popup/contact-us'
  import { i18n } from '@js/i18n'

  export default {
    name: 'AdditionalMenu',
    components: {
      MenuItem,
      ContactUs
    },
    data () {
      return {
        i18n,
        item: {
          icon: '/static/img/contact_us_icon.svg',
          tooltipText: i18n.lbl_contact_us(),
          routerLink: '',
          visibilityRules: true
        },
        showDialog: false
      }
    },
    methods: {
      openDialog () {
        this.showDialog = true
      },
      closeDialog () {
        this.showDialog = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/variables";

  .additional-menu {
    border-radius: 999px;
    padding: 10px;
    background-color: $color-white;
    box-shadow: 4px 4px 4px 0 rgba(134, 134, 134, 0.2);
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/AdditionalMenu.vue